export const contactsData = {
    email: 'urrgb29@gmail.com',
    phone: '+91 9654004473',
    address: '44A, Block YP, Maurya Enclave, Pitampura, Delhi-110034',

    sheetAPI: ''
}